/// <amd-module name="Build/Admin/Common/Actions/ProjectActionCreator" />
import { IReadonlyObservableArray, IObservableArrayEventArgs } from "VSS/Core/Observable";
import { IVssPageContext } from "VSS/Platform/Context";

import { ITfsProjectService, ITeamProject } from "TFS/Services/TfsProjectService";

import { ProjectActions } from "Build/Admin/Common/Actions/ProjectActions";

export interface IProjectActionCreatorOptions {
    pageContext: IVssPageContext;
    projectActions: ProjectActions;
}

export class ProjectActionCreator {
    private _projectActions: ProjectActions;
    private _tfsProjectService: ITfsProjectService;
    private _projectsArray: IReadonlyObservableArray<ITeamProject>;
    private _initialized: boolean;

    constructor(options: IProjectActionCreatorOptions) {
        this._initialized = false;
        this._projectActions = options.projectActions;
        this._tfsProjectService = options.pageContext.getService<ITfsProjectService>("ITfsProjectService");
    }

    public dispose(): void {
        if (this._projectsArray) {
            this._projectsArray.unsubscribe(this._projectsEvent);
        }
    }

    public initializeProjects(): void {
        if (!this._initialized) {
            this._projectsArray = this._tfsProjectService.getAllProjects();
            this._projectActions.projectsUpdated.invoke(this._projectsArray.value);
            this._projectsArray.subscribe(this._projectsEvent);
            this._initialized = true;
        }
    }

    private _projectsEvent = (value: IObservableArrayEventArgs<ITeamProject>): void => {
        this._projectActions.projectsUpdated.invoke(this._projectsArray.value);
    }
}
